import React, { useState } from 'react';
import '../../styles/AdminModal.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import useBoatActions from '../../hooks/AdminBoatsPage/useBoatActions';

const BoatsBulkDeleteModal = ({ isOpen, onClose, onSuccess, boats }) => {
  const [loading, setLoading] = useState(false);
  const { handleBulkDelete } = useBoatActions();

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await handleBulkDelete(boats);
      await onSuccess();
      onClose();
    } catch (error) {
      // Handle error if needed
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Delete Boats</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div className="admin__modal-body">
          <div className="admin__modal-body__delete_items">
            <p>
              Are you sure you want to delete the following {boats.length} {boats.length === 1 ? 'boat' : 'boats'}?
            </p>
            <div className="admin__modal-body__delete_items_container">
              <ul>
                {boats.map(boat => (
                  <li key={boat.id}>
                    <strong>{boat.name}</strong> (ID #{boat.id}, Type: {boat.type})
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            {loading ? 'Processing...' : 'Cancel'}
          </button>
          <button className="button" onClick={handleConfirm} disabled={loading}>
            {loading ? 'Processing...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BoatsBulkDeleteModal;